module.exports = "../../map/Kanagawa/map/agriculture/Kanagawa_AgricultureTankan_CMIP5RCP26_MRI_No_R2081_2100.png";